import React from "react";
import blogsData from "./blogsData";
import "./blog.css";

import { NavLink } from "react-router-dom";

export default function Blogs() {
  return (
    <div className="page">
      <div className="row no-gutters row-layout">
        <div className="col-lg col-layout2">
          <div className="blog-column">
            <h2>Blogs</h2>
            {blogsData.map((blog, index) => {
              const { title, body, url } = blog;
              return (
                <div className="blog__panel" key={index}>
                  <h4>{title}</h4>
                  <p>{body}</p>
                  {/* <a href={url} className="blog__btn">
                    Read More
                  </a> */}

                  <NavLink to={url} className="blog__btn">
                    Read More
                  </NavLink>
                  <hr />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
